import React from "react";
import {Row, Col} from "antd";
import BarChart from "./BarChart";
import PieChart from "./PieChart";
const Chart = () => {
  return (
    <div style={{width: "100%"}}>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <BarChart></BarChart>
        </Col>
        <Col span={12}>
          <PieChart></PieChart>
        </Col>
      </Row>
    </div>
  );
};
export default Chart;
